export const setCurrentNavLabel = $label => label => $label.text(label);

